import React from 'react';
import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';

import { Container, Segment, Image } from 'semantic-ui-react';
import logo from "../../images/logo/logo-full-black.png";
import queryString from "query-string";
import LoadingComponent from "../common/LoadingComponent";

import {getToken} from "../../services/auth0.js";

class SSOSuccess extends React.Component {

    constructor(props) {
        super(props);
    }

    async componentDidMount() {
        const ssoConfig = { ...this.props.ssoConfig}
        dispatch.app.handleRedirect(ssoConfig);
        this.setState({ loading: false })
    }

    render() {
        return (
            <div>
                <Segment clearing>
                    <div style={{ "float": "left" }} >
                        <Image src={logo} size='small' centered={true} />
                    </div>
                </Segment>
                <Container>
                    <LoadingComponent active={true} message="SSO login Successful. Redirecting to the application" />    
                </Container>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        ssoConfig: state.app.ssoConfig,
    };
}

const connectedSSOSuccess = connect(mapStateToProps)(SSOSuccess);

export { connectedSSOSuccess as SSOSuccess }; 